<template>
  <div class="bgFrame">
    <div
      class="box"
      style="z-index: 430; display: flex; justify-content: center"
    >
      <div style="z-index: 431;position:absolute;left:0px;width:1582px;bottom:0px;top:0px;background:#8CA866;"></div>
      <div :class="boxClass"></div>
    </div>
    <div class="boxs" :style="'background-image: url(' + pointImg + ');'">
    </div>
    <div
      class="box"
      style="z-index: 501; display: flex; justify-content: center;align-items: flex-start;"
    >
      <div :class="titleClass">
        <div id="headText">Feedback<br>Suggestions</div>
        <div style="width: 100%; margin-top: 143px;"></div>
        <div style="display: flex; justify-content: center">
          <div class="textSubFrame">回饋建議</div>
        </div>
        <div style="width: 100%; margin-top: 10px;"></div>
        <div style="display: flex; justify-content: center">
          <div class="textContent">
            我們十分重視你的健康需求質建議！
            <br />閣下可通過以下方式聯絡我們提供寶貴的建議及創意
          </div>
        </div>
        <div style="width: 100%; margin-top: 10%;"></div>
        <div>
          <el-form
          :rules="rules"
          label-position="top"
            ref="formRef"
            :model="dynamicValidateForm"
            label-width="120px"
            class="demo-dynamic"
          >
          <el-form-item
              prop="name"
              label="聯繫人姓名/暱稱"
            >
            <el-input id="input2" v-model="dynamicValidateForm.name" placeholder="聯繫人姓名/暱稱" />
            </el-form-item>
            <el-form-item
              prop="email"
              label="電郵"
            >
              <el-input id="input2" v-model="dynamicValidateForm.email" placeholder="電郵" />
            </el-form-item>
            <el-form-item
              prop="content"
              label="具體內容"
            >
              <el-input id="input3" v-model="dynamicValidateForm.content" type="textarea" resize="none" placeholder="具體內容" />
            </el-form-item>
            <el-form-item>
                 <el-button round class="orderBtn" color="#6B834B" size="large" @click="submitForm">送出</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { addOpinion } from "../../api/index";
import { ElMessage } from "element-plus";

export default {

  name: "App",
  components: {},
  setup() {
    onMounted(() => {});
    const formRef = ref(null)
    const dynamicValidateForm = ref({
        name : '',
        email: '',
        content : ''
    })
    let titleClass = ref("start_textFrame");
    const startAnime = ref(false);
    let boxClass = ref('box_normal')
    const changeAnime = (show) => {
      startAnime.value = show
      if (startAnime.value == false) {
        boxClass.value = 'box_normal'
        titleClass.value = "start_textFrame";
        setTimeout(() => {
          boxClass.value = 'box_anime'
          titleClass.value = "textFrame";
          setTimeout(() => {
            let a = document.getElementById('headText')
            a.style.display = 'flex';
          }, 1500);
        }, 800);
      }
    };
    const validateMail = (rule, value, callback)=>{
      if (value === '') {
        return true
      } else {
        // eslint-disable-next-line no-useless-escape
        if (/^[\w\.-]+@[a-z0-9\-]+(\.[a-z]{2,6}){1,3}$/i.test(value) === false) {
          callback(new Error('請輸入正確電郵'))
        }else {
          return true
        }
      }
    };
    const rules = {
      email: [
        {required: true, validator: validateMail, trigger: 'blur' }
      ]
    };

    const submitForm = () => {
      formRef.value.validate((valid) => {
        if (valid) {
          if (dynamicValidateForm.value.email == '') {
            ElMessage.error('請輸入正確電郵')
            return
          }
          if (dynamicValidateForm.value.name == '') {
            ElMessage.error('請輸入姓名/暱稱')
            return
          }
          if (dynamicValidateForm.value.content == '') {
            ElMessage.error('請輸入具體內容')
            return
          }
          addOpinion({
            name : dynamicValidateForm.value.name,
            email: dynamicValidateForm.value.email,
            content: dynamicValidateForm.value.content
          }).then((res) => {
            if (res.errCode === 200) {
              ElMessage.success("意見回饋成功，請等待客服與您聯系");
              dynamicValidateForm.value = {name: '', email: '', content :''}
            } else {
              ElMessage.error(res.data.msg);
            }
          });
        } else {
          return false;
        }
      });
    };

    let pointImg = ref(require('../../assets/noise.png'))
    return {
      boxClass,
      pointImg,
      validateMail,
      submitForm,
      dynamicValidateForm,
      formRef,
      startAnime,
      changeAnime,
      titleClass,
      rules
    };
  },
};
</script>

<style lang="less" scoped>
@keyframes boxAnime {
  from {
      opacity: 0;
  }
  to {
      opacity: 1;
  }
}
.box_anime{
  z-index: 432;
  position:absolute;
  left:19%;
  right:0px;
  bottom:0px;
  top:0px;
  border-top-left-radius: 300px;
  background:#E5E9D8;
  opacity: 1;
  animation-duration: 2s;
  animation-name: boxAnime;
}
.box_normal{
  z-index: 432;
  position:absolute;
  left:19%;
  right:0px;
  bottom:0px;
  top:0px;
  border-top-left-radius: 300px;
  background:#E5E9D8;
  opacity: 0;
}
.bgFrame {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: rgb(235, 242, 241);
}
.box {
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  
  align-items: center;
}
@keyframes textAnime {
  from {
    transform: translate(0px, 20px);
    opacity: 0.5;
  }
  to {
    transform: translate(0px, 0px);
    opacity: 1;
  }
}
.textFrame {
  width: 572px;
  display: flex;
  opacity: 1;
  flex-direction: column;
  align-content: center;
  animation-name: textAnime;
  animation-duration: 1s;
  animation-timing-function: ease-in-out;
}
.start_textFrame {
  width: 572px;
  display: flex;
  opacity: 0;
  flex-direction: column;
  align-content: center;
}
.textSubFrame {
  font-size: 57px;
  font-family: MicrosoftYaHeiLight;
  color: #685647;
  line-height: 76px;
}
.textContent {
  width: 100%;
  font-size: 16px;
  font-family: MicrosoftYaHeiLight;
  color: #685647;
  line-height: 29px;
}
:deep(#input2) {
    width: 100%;
    height: 57px;
}
:deep(.el-textarea){
    width: 100%;
    height: 202px;
    font-size: 18px;
    line-height: 25px;
    --el-input-focus-border-color: #6B834B;
    --el-input-clear-hover-color:rgba(0,0,0,0);
}
:deep(.el-input){
  font-size: 18px;
  line-height: 25px;
  --el-input-focus-border-color: #6B834B;
  --el-input-clear-hover-color:rgba(0,0,0,0);
}
:deep(.el-input__wrapper){
  border-radius: 8px !important;
}
:deep(.el-textarea__inner){
  padding-top: 10px !important;
  border-radius: 8px !important;
}
:deep(.el-form-item__label){
  font-size: 18px !important;
}
:deep(#input3){
    width: 100%;
    height: 202px;
}
.orderBtn{
  width: 100%;
  height: 57px;
  border-radius: 28px !important;
  :deep(span){
    font-size: 18px;
    font-family: MicrosoftYaHei;
  }
}

@keyframes pointAnime{
  0% {
    transform: translate3d(0,9px,0)
  }
  10% {
    transform: translate3d(-1px,-4px,0)
  }
  20% {
    transform: translate3d(-8px,2px,0)
  }
  30% {
    transform: translate3d(-9px,-9px,0)
  }
  40% {
    transform: translate3d(2px,7px,0)
  }
  50% {
    transform: translate3d(9px,-4px,0)
  }
  60% {
    transform: translate3d(2px,6px,0)
  }
  70% {
    transform: translate3d(7px,-8px,0)
  }
  80% {
    transform: translate3d(-9px,1px,0)
  }
  90% {
    transform: translate3d(6px,-5px,0)
  }
  to {
    transform: translate3d(-7px,0,0)
  }
}
.boxs {
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 501;
  position: absolute;
  background-position:50%;
  animation :pointAnime 1s steps(2) infinite;
}

#headText {
  position: absolute;
  left: 1166px;
  bottom:54px;
  text-align: left;
  font-size: 102px;
  font-family: DINCondensed-Bold, DINCondensed;
  font-weight: bold;
  color: rgba(128, 113, 101, 0.1);
  line-height: 100px;
  display: none;
}
:deep(.el-form--default.el-form--label-top .el-form-item .el-form-item__label) {
  display: none;
}

</style>
